module.exports = __webpack_public_path__ + "static/3-e94899b10da07c7653b62b76a9cf65c1.jpg";